import { Icon, Avatar, Text } from '@livechat/design-system-react-components';
import { ChevronDown as ChevronDownIcon } from '@livechat/design-system-icons';
import { popoverContainerStyles, popoverEmailStyles } from './styles';

interface IProfileDropdownPopoverProps {
  avatarUrl: string | null;
  accountName: string;
  accountEmail: string;
}

export const ProfileDropdownPopover = ({
  avatarUrl,
  accountName,
  accountEmail,
}: IProfileDropdownPopoverProps) => {
  const checkForLongEmail = (email: string) => {
    if (email?.length > 36) {
      return `${email.substring(0, 36)}...`;
    }
    return email;
  };

  return (
    <div css={popoverContainerStyles} data-testid="profile-dropdown">
      {avatarUrl ? (
        <Avatar type="image" src={avatarUrl} size="small" />
      ) : (
        <Avatar type="text" text={accountName} />
      )}
      <Text bold css={popoverEmailStyles}>
        {checkForLongEmail(accountEmail)}
      </Text>
      <Icon source={ChevronDownIcon} />
    </div>
  );
};
